<div class="dialog-title">
  <h1>{{"Schedule" | translate}}</h1>
  <p class="dialog-title__appointment">{{appointmentSchedule}}</p>
</div>

<mat-dialog-content
  *ngIf="data$ | async as data; else loading"
  class="schedule-reschedule-dialog"
  [class.is-saving]="isSaving || false"
>
  <form [formGroup]="scheduleForm">
    <section class="overflow-hidden owner">
      <h2 class="section-title">
        {{"OwnerData" | translate}}
        <i
          class="bi bi-pencil-fill edit"
          (click)="editOwnerAndChangeOwner(3)"
          *ngIf="isEditable"
        ></i>
      </h2>

      <mat-button-toggle-group class="owner__options" *ngIf="editButton">
        <mat-button-toggle (click)="editOwnerAndChangeOwner(1)">
          {{"EditOwner" | translate}}
        </mat-button-toggle>
        <mat-button-toggle (click)="editOwnerAndChangeOwner(2)">
          {{"UpdateOwner" | translate}}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <!-- Show Owner Data -->
      <div class="schedule-reschedule-dialog__grid" *ngIf="!isEditingOwner">
        <p class="owner__data-field">
          <span class="bold">{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') | translate}}: </span>{{
          nombres?.value }}
        </p>
        <p class="owner__data-field" *ngIf="showLastName">
          <span class="bold">{{"LastName" | translate}}: </span>{{
          apellidos?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"PersonType" | translate}}: </span>{{
          appointment.customerPersonType }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"Typededoc" | translate}}: </span>{{
          appointment.customerDocType }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"NumerDocument" | translate}}: </span>{{
          numeroDeDocumento?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold"
            >{{"CustomerVehicleRelationship" | translate}}: </span
          >{{customerVehicleRelationShipName }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"Phone" | translate}}: </span>{{ celular?.value
          }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"Email" | translate}}: </span>{{ email?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"Model" | translate}}: </span>{{ model?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"year" | translate}}: </span>{{ year?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"Plate" | translate}}: </span>{{ placa?.value }}
        </p>
        <p class="owner__data-field">
          <span class="bold">{{"VIN" | translate}}: </span>{{ vinNo?.value }}
        </p>
      </div>

      <!-- Edit Owner Data-->
      <div
        class="owner-form schedule-reschedule-dialog__grid"
        *ngIf="isEditingOwner"
        formGroupName="owner"
      >
        <mat-form-field>
          <mat-label>{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') | translate}}</mat-label>
          <input type="text" matInput formControlName="nombres" oninput="value = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜ ñÑ.,-]/g, '')"/>
          <mat-error *ngIf="nombres!.hasError('required')">
            {{"NameIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="nombres!.hasError('noSpecialChars')">
            {{"SpecialCharacters" | translate}}
            <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="nombres!.hasError('noNumbers')">
            {{"numberNotAllowed" | translate}}
            <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="showLastName">
          <mat-label>{{"LastName" | translate}}</mat-label>
          <input type="text" matInput formControlName="apellidos" oninput="value = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜ ñÑ.,-]/g, '')"/>
          <mat-error *ngIf="apellidos!.hasError('required')">
            {{"LastNameIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="apellidos!.hasError('noSpecialChars')">
            {{"SpecialCharacters" | translate}}
            <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="nombres!.hasError('noNumbers')">
            {{"numberNotAllowed" | translate}}
            <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"PersonType" | translate}}</mat-label>
          <mat-select formControlName="tipoDePersona">
            <mat-option
              *ngFor="let typeOfPerson of data.personTypes"
              [value]="typeOfPerson.typeId"
              >{{typeOfPerson.typeName}}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{"Typededoc" | translate}}</mat-label>
          <mat-select formControlName="tipoDeDocumento" >
            <mat-option
              *ngFor="let typeOfDocument of documentTypesByPersonType"
              [value]="typeOfDocument.typeId"
              >{{typeOfDocument.typeName}}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="tipoDeDocumento!.hasError('required')">
            {{"DocumentTypeIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"NDocument" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="numeroDeDocumento"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="20"
          />
          <mat-error *ngIf="numeroDeDocumento!.hasError('required')">
            {{"DocumentNumberIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="numeroDeDocumento!.hasError('noSpecialChars')">
            {{"SpecialCharacters" | translate}}
            <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"CustomerVehicleRelationship" | translate}}</mat-label>
          <mat-select formControlName="relacionClienteVehiculo">
            <mat-option
              *ngFor="let relation of data.vehicleRelationships"
              [value]="relation.relationshipVehicleId"
            >
              {{relation.relationshipName | translate}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="relacionClienteVehiculo!.hasError('required')">
            {{"RelationshipIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"Phone" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="celular"
            oninput="value = value.replace(/[^0-9 ]/g, '')"
            maxlength="20"
          />
          <mat-error *ngIf="celular!.hasError('numbersOnly')">
            {{ 'onlyNumbersAllowed' | translate }}
          </mat-error>
          <mat-error *ngIf="celular!.hasError('required')">
            {{"PhoneIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"Email" | translate}}</mat-label>
          <input type="email" matInput formControlName="email" maxlength="50" />
          <mat-error *ngIf="email!.hasError('invalidEmail')">
            {{"EmailNotValid" | translate}}
          </mat-error>
          <mat-error *ngIf="email!.hasError('required')">
            {{"EmailIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
          
        </mat-form-field>
        <!-- añop y modelo -->
        <mat-form-field>
          <mat-label>{{"Model" | translate}}</mat-label>
          <mat-select formControlName="model" [disabled]="EnableVehicleandModel">
            <mat-option
              *ngFor="let dataModel of appointment.modelVehicle"
              [value]="dataModel"
              >{{dataModel}}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="model!.hasError('required')">
            {{"DocumentTypeIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

          <mat-form-field>
          <mat-label>{{"year" | translate}}</mat-label>
          <mat-select formControlName="año" [disabled]="EnableVehicleandModel">
            <mat-option
              *ngFor="let dataModel of YearsShow"
              [value]="dataModel"
              >{{dataModel}}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="year!.hasError('required')">
            {{"DocumentTypeIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="isNewUser">
          <mat-label>{{"Plate" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="placa"
           oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="12"
            minlength="5"
          />
          <mat-error *ngIf="placa!.hasError('required')">
            {{"PlateIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="placa!.hasError('minlength')">
            {{"PlateMustHave" | translate}}
            <strong>{{"MinimumFiveCharacters" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="isNewUser || isEditingOwner">
          <mat-label>{{"VIN" | translate}}</mat-label>
          <input type="text" matInput formControlName="vin" maxlength="17"oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"/>
          <mat-error *ngIf="vinNo!.hasError('required')">
            {{"VinIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="vinNo!.hasError('noSpecialChars')">
            {{"OnlyAlphanumericCharacters" | translate}}
          </mat-error>
          <mat-error *ngIf="vinNo!.hasError('minlength')">
            {{"VinMust" | translate}}
            <strong>{{"MinimumFiveCharacters" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <!-- <p class="owner__data-field" *ngIf="!isNewUser">
          <span class="bold">{{"VIN" | translate}}: </span>{{ vinNo?.value }}
        </p> -->
      </div>
    </section>

    <!-- Schedule -->
    <ng-container class="reservation">
      <h2 class="section-title">{{"ReservationData" | translate}}</h2>

      <!-- CONTACT CENTER ROLE ID 3-->
      <div
        class="row"
        formGroupName="schedule"
        *ngIf="currentUserRoleId === 3 || currentUserRoleId === 4"
      >
        <ng-container *ngIf="isThereABlockForRole; else schedule">
          <h2 class="errorBloqueo">{{"CantSchedule" | translate}}</h2>
        </ng-container>

        <ng-template #schedule>
          <div class="col-lg-6">
            <p class="owner__data-field">
              <span class="bold">{{"Brand" | translate}}: </span
              >{{this.appointment.brand.brandName}}
            </p>
          </div>
          <div class="col-lg-6">
            <p class="owner__data-field">
              <span class="bold">{{"City" | translate}}: </span
              >{{this.appointment.city.cityName}}
            </p>
          </div>
          <div class="col-lg-6">
            <p class="owner__data-field">
              <span class="bold">{{"TypeOfService" | translate}}: </span
              >{{this.appointment.typeOfService.serviceName | translate}}
            </p>
          </div>
          <div class="col-lg-6">
            <p class="owner__data-field">
              <span class="bold">{{"Workshop" | translate}}: </span
              >{{this.appointment.workshop.workshopName}}
            </p>
          </div>
          <div class="col-lg-6">
            <mat-form-field *ngIf="!isAdvisorSelected">
              <mat-label>{{"Advisor" | translate}}</mat-label>
              <mat-select formControlName="asesor">
                <mat-option
                  *ngFor="let advisor of allAvailableAdvisors"
                  [value]="advisor.advisorId"
                  >{{ advisor.advisorFullName }}</mat-option
                >
              </mat-select>
              <mat-error *ngIf="asesor!.hasError('required')">
                {{"AdvisorIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
            <p class="owner__data-field" *ngIf="isAdvisorSelected">
              <span class="bold">{{"Advisor" | translate}}: </span
              >{{appointment.advisor.advisorFullName}}
            </p>
          </div>
          <div class="col-lg-6">
            <mat-form-field>
              <mat-label>{{"Channel" | translate}}</mat-label>
              <mat-select formControlName="canal">
                <mat-option
                  *ngFor="let channel of data.channels"
                  [value]="channel.originId"
                  >{{channel.originName}}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <mat-form-field>
              <mat-label>{{"Mileage" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="kilometraje"
                maxlength="6"
             oninput="value = value.replace(/[^0-9 ]/g, '')"

              />
              <mat-error *ngIf="kilometraje!.hasError('required')">
                {{"MileageIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
                {{"OnlyAlphanumericCharacters" | translate}}
              </mat-error>
              <mat-error *ngIf="kilometraje!.hasError('numbersOnly')">
                {{ 'onlyNumbersAllowed' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12">           
             <mat-form-field>
              <mat-label>{{"Observations" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="observacion"
                oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
                maxlength="1000"
                (input)="charCount = scheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
              />
              <mat-hint align="start">{{ charCount }}/1000</mat-hint>
            </mat-form-field>
            
          </div>
        </ng-template>
      </div>

      <!-- WORKSHOP ROLE ID 2 y 6-->
      <div
        class="schedule-reschedule-dialog__grid"
        formGroupName="schedule"
        *ngIf="currentUserRoleId === 2 || currentUserRoleId === 6"
      >
        <ng-container *ngIf="isThereABlockForRole; else schedule">
          <h2 class="errorBloqueo">{{"CantSchedule" | translate}}</h2>
        </ng-container>

        <ng-template #schedule>
          <div class="">
            <p class="owner__data-field" *ngIf="isAdvisorSelected">
              <span class="bold">{{"Advisor" | translate}}: </span
              >{{appointment.advisor.advisorFullName}}
            </p>
          </div>

          <div class="">
            <p class="owner__data-field">
              <span class="bold">{{"TypeOfService" | translate}}: </span
              >{{this.appointment.typeOfService.serviceName | translate}}
            </p>
          </div>

          <div class="">
            <p class="owner__data-field">
              <span class="bold">{{"Brand" | translate}}: </span
              >{{this.appointment.brand.brandName}}
            </p>
          </div>

          <div class="">
            <mat-form-field>
              <mat-label>{{"Mileage" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="kilometraje"
                maxlength="6"
                oninput="value = value.replace(/[^0-9 ]/g, '')"
              />
              <mat-error *ngIf="kilometraje!.hasError('required')">
                {{"MileageIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
                {{"OnlyAlphanumericCharacters" | translate}}
              </mat-error>
              <mat-error *ngIf="kilometraje!.hasError('numbersOnly')">
                {{ 'onlyNumbersAllowed' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <p class="owner__data-field">
              <span class="bold">{{"Channel" | translate}}: </span>{{
              canal?.value }}
            </p>
            <!-- <mat-form-field>
              <mat-label>{{"Channel" | translate}}</mat-label>
              <mat-select formControlName="canal">
                <mat-option
                  *ngFor="let channel of data.channels"
                  [value]="channel.originId"
                  >{{channel.originName}}</mat-option
                >
              </mat-select>
            </mat-form-field> -->
          </div>

          <div class="schedule-reschedule-dialog__grid-element--wide">
            <mat-form-field>
              <mat-label>{{"Observations" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="observacion"
                maxlength="1000"
               oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
                (input)="charCount = scheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
              />
              <mat-hint align="start">{{ charCount }}/1000</mat-hint>
            </mat-form-field>
          </div>
        </ng-template>
      </div>

      <!-- SERVICE ADVISOR ROLE ID 1 -->
      <div
        class="schedule-reschedule-dialog__grid"
        formGroupName="schedule"
        *ngIf="currentUserRoleId === 1"
      >
        <div class="">
          <mat-form-field>
            <mat-label>{{"Brand" | translate}}</mat-label>
            <mat-select formControlName="marca">
              <mat-option
                *ngFor="let brand of brandsAvailable"
                [value]="brand.brandId"
                >{{brand.brandName}}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <div class="">
          <mat-form-field *ngIf="allServices.length">
            <mat-label>{{"TypeOfService" | translate}}</mat-label>
            <mat-select formControlName="tipoDeServicio">
              <mat-option
                *ngFor="let service of allServices"
                [value]="service.serviceId"
                >{{service.serviceName | translate}}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <p class="owner__data-field" *ngIf="!allServices.length">
            <span class="bold">{{"NoServicesAvailable" | translate}}</span>
          </p>
        </div>

        <div class="">
          <mat-form-field>
            <mat-label>{{"Mileage" | translate}}</mat-label>
            <input
              type="text"
              matInput
              formControlName="kilometraje"
              maxlength="6"
              oninput="value = value.replace(/[^0-9 ]/g, '')"
            />
            <mat-error *ngIf="kilometraje!.hasError('required')">
              {{"MileageIs" | translate}}
              <strong>{{"Required" | translate}}</strong>
            </mat-error>
            <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
              {{"OnlyAlphanumericCharacters" | translate}}
            </mat-error>
            <mat-error *ngIf="kilometraje!.hasError('numbersOnly')">
              {{ 'onlyNumbersAllowed' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <p class="owner__data-field channel">
            <span class="bold">{{"Channel" | translate}}: </span>{{ canal?.value
            }}
          </p>
          <!-- <mat-form-field>
            <mat-label>{{"Channel" | translate}}</mat-label>
            <mat-select formControlName="canal">
              <mat-option
                *ngFor="let channel of data.channels"
                [value]="channel.originId"
                >{{channel.originName}}</mat-option
              >
            </mat-select>
          </mat-form-field> -->
        </div>

        <div class="schedule-reschedule-dialog__grid-element--wide">        
          <mat-form-field>
            <mat-label>{{"Observations" | translate}}</mat-label>
            <input
              type="text"
              matInput
              formControlName="observacion"
             oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
              maxlength="1000"
              (input)="charCount = scheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
            />
            <mat-hint align="start">{{ charCount }}/1000</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Edit Representative Data-->
      <div formGroupName="representative">
        <div class="schedule-reschedule-dialog__radios">
          <div class="">
            <p>{{"OwnerWillBeOnSite" | translate}}</p>
          </div>

          <div class="">
            <mat-radio-group
              aria-label="Select an option"
              formControlName="duenoSePresentara"
            >
              <mat-radio-button [value]="true" labelPosition="before"
                >{{"Yes" | translate}}</mat-radio-button
              >
              <mat-radio-button [value]="false" labelPosition="before"
                >{{"No" | translate}}</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>

        <section
          *ngIf="scheduleForm.controls.representative.get('duenoSePresentara')?.value===false"
        >
          <h2 class="section-title">
            {{"RepresentativeInformation" | translate}}
          </h2>

          <section class="schedule-reschedule-dialog__grid">
            <mat-form-field>
              <mat-label>{{"FirstName" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="nombresRepresentante"
               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                maxlength="40"
              />
              <mat-error *ngIf="nombresRepresentante!.hasError('required')">
                {{"NameIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error
                *ngIf="nombresRepresentante!.hasError('noSpecialChars')"
              >
                {{"SpecialCharacters" | translate}}
                <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="nombres!.hasError('noNumbers')">
                {{"numberNotAllowed" | translate}}
                <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"LastName" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="apellidosRepresentante"
               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                maxlength="40"
              />
              <mat-error *ngIf="apellidosRepresentante!.hasError('required')">
                {{"LastNameIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error
                *ngIf="apellidosRepresentante!.hasError('noSpecialChars')"
              >
                {{"SpecialCharacters" | translate}}
                <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="nombres!.hasError('noNumbers')">
                {{"numberNotAllowed" | translate}}
                <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"Typededoc" | translate}}</mat-label>
              <mat-select formControlName="tipoDeDocumentoRepresentante">
                <mat-option
                  *ngFor="let typeOfDocument of representativeDocumentTypes"
                  [value]="typeOfDocument.typeId"
                  >{{typeOfDocument.typeName}}</mat-option
                >
              </mat-select>
              <mat-error
                *ngIf="tipoDeDocumentoRepresentante!.hasError('required')"
              >
                {{"DocumentTypeIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"NDocument" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="numeroDeDocumentoRepresentante"
                oninput="value = value.replace(/[^0-9 ]/g, '')"
                maxlength="12"
              />
              <mat-error
                *ngIf="numeroDeDocumentoRepresentante!.hasError('required')"
              >
                {{"DocumentNumberIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="numeroDeDocumentoRepresentante!.hasError('noSpecialChars')">
                {{"SpecialCharacters" | translate}}
                <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"Phone" | translate}}</mat-label>
              <input
                type="text"
                matInput
                formControlName="celularRepresentante"
                oninput="value = value.replace(/[^0-9 ]/g, '')"
                maxlength="15"
              />
              <mat-error *ngIf="celularRepresentante!.hasError('numbersOnly')">
                {{ 'onlyNumbersAllowed' | translate }}
              </mat-error>
              <mat-error *ngIf="celularRepresentante!.hasError('required')">
                {{"PhoneIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{"email" | translate}}</mat-label>
              <input
                type="email"
                matInput
                formControlName="emailRepresentante"
                maxlength="50"
              />
              <mat-error *ngIf="emailRepresentante!.hasError('email')">
                {{"EmailNotValid" | translate}}
              </mat-error>
              <mat-error *ngIf="emailRepresentante!.hasError('required')">
                {{"EmailIs" | translate}}
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="email!.hasError('dotCom')">
                .com
                <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </section>

          <!-- End represetntative form section-->
        </section>

        <!-- End edit representative-->
      </div>

      <!-- End schedule section-->
    </ng-container>

    <!-- Terminos, condiciones y politicas -->
    <section class="termsAndPolitics">
      <div class="" formGroupName="termsAndPolitics">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-6">
              <p>
                {{"IAgree" | translate}}
                <span>
                  <a class="highlight" [href]="termsAndpoliticsLink">
                    {{"TermsAndConditions" | translate}}
                  </a></span
                >
              </p>
              <mat-error
                *ngIf="terminos!.hasError('yesSelected') && terminos!.dirty && terminos!.value===false "
              >
                {{"MustAgreeToTermsAndConditions" | translate}}
              </mat-error>
            </div>

            <div class="col-lg-6">
              <mat-radio-group
                aria-label="Select an option"
                formControlName="terminos"
              >
                <mat-radio-button [value]="true" labelPosition="before"
                  >{{"Yes" | translate}}</mat-radio-button
                >
                <mat-radio-button [value]="false" labelPosition="before"
                  >{{"No" | translate}}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="row">
            <div
              class="col-lg-6"
              *ngIf="currentLanguage == 'du-BE' || currentLanguage == 'fr-BE' && countryId !== 2"
            >
              <p>
                <span class="highlight">{{"politicsBelgica1"| translate}}</span>
                {{"politicsBelgica2" | translate}}
              </p>
              <mat-error
                *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
              >
                {{"MustAgreeToDataProtectionPolicy" | translate}}
              </mat-error>
            </div>

            <div
              class="col-lg-6"
              *ngIf="currentLanguage !== 'du-BE' && currentLanguage !== 'fr-BE' && countryId !== 2 && countryId !== 1"
            >
              <p>
                {{"DeclareToKnowAndUnderstand"| translate}}
                <span class="highlight"
                  >{{"PersonalDataProtectionPolicy" | translate}}</span
                >
                {{"AndAuthorize" | translate}}
              </p>
              <mat-error
                *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
              >
                {{"MustAgreeToDataProtectionPolicy" | translate}}
              </mat-error>
            </div>

            <div
              class="col-lg-6"
              *ngIf="countryId === 1"
            >
              <p>
                {{"habeasDataText"| translate}}
                
              </p>
              <mat-error
                *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
              >
                {{"MustAgreeToDataProtectionPolicy" | translate}}
              </mat-error>
            </div>
            <!-- Peru -->
            <div
            class="col-lg-6"
            *ngIf=" countryId === 2"
          >
          <p>
            {{"DataProcessing1" | translate}}
            <span>
              <a class="highlight" [href]="termsAndpoliticsLink">{{"DataProcessing2" | translate}}</a></span>{{"DataProcessing3" | translate}} 
          </p>
            <mat-error
              *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
            >
              {{"MustAgreeToDataProtectionPolicy" | translate}}
            </mat-error>
          </div>
            <div class="col-lg-6">
              <mat-radio-group
                aria-label="Select an option"
                formControlName="politicas"
              >
                <mat-radio-button [value]="true" labelPosition="before"
                  >{{"Yes" | translate}}</mat-radio-button
                >
                <mat-radio-button [value]="false" labelPosition="before"
                  >{{"No" | translate}}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>

        <!-- Peru -->
        <div class="col-lg-12" *ngIf="countryId === 2">
          <div class="row">
            <div class="col-lg-6">
              <p>
                {{"DataSendPeru1" | translate}}
                <span>
                  <a class="highlight" [href]="termsAndpoliticsLink">   {{"DataSendPeru2" | translate}}</a></span>
              </p>
            </div>

            <div class="col-lg-6">
              <mat-radio-group
                aria-label="Select an option"
                formControlName="DataPeru"
              >
                <mat-radio-button [value]="true" labelPosition="before"
                  >{{"Yes" | translate}}</mat-radio-button
                >
                <mat-radio-button [value]="false" labelPosition="before"
                  >{{"No" | translate}}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>

        
      </div>
      <!-- End terminos condiciones politicas-->
    </section>
  </form>
</mat-dialog-content>

<ng-template #loading>
 
  <section  class="dialog-loading-container">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing" >{{ "Loading" | translate }}...</p>
  </section>
</ng-template>
<section  class="dialog-loading-container" *ngIf="isSaving">
  <div  class="pulsing" >
    <mat-spinner [diameter]="50" ></mat-spinner>
  </div>
  <p class="pulsing" >{{ "Loading" | translate }}...</p>
</section>


<mat-dialog-actions align="center">
  <button [mat-dialog-close] class="dialog__button" *ngIf="!isSaving">
    {{"Cancel" | translate}}
  </button>
  <button
    class="dialog__button dialog__button__accept"
    (click)="onSave()"
    *ngIf="!isSaving"
    [disabled]="validatorsForm()"
  >
    {{"Accept" | translate}}
  </button>
</mat-dialog-actions>
